import { changeLogActions } from './slice';
import { ReduxAction } from '../utils/utils';

export const fetchChangeLog = changeLogActions.fetchChangeLog as (
  payload: string,
) => ReduxAction;
